export default {
  computed: {
    headersCupom() {
      return [
        {
          text: this.$t('sales.coupon'),
          align: "start",
          sortable: true,
          value: "codigo",
          width: 200,
        },
        {
          text: this.$t('sales.total_quantity'),
          align: "end",
          sortable: true,
          value: "quantidade",
          width: 200,
        },
        {
          text: this.$t('sales.discount_percent'),
          align: "end",
          sortable: true,
          value: "perc_desconto",
          width: 200,
        },
        {
          text: this.$t('sales.coupon_discount_value'),
          align: "end",
          sortable: true,
          value: "valor_desconto",
          width: 200,
        },
        {
          text: this.$t('sales.coupon_actions'),
          align: "center",
          sortable: false,
          width: 200,
          value: "actions",
        },
      ];
    },
    options5() {
      return {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      };
    },
  },
  methods: {
    openModalSelect() {
      this.$cupom_desconto.lojas_loading = true;
      this.$cupom_desconto.loja_selecionada = "";
      this.$cupom_desconto.modalSelectStore = true;
    },
  },
};
